/*
 * Header Messages
 *
 * This contains all the text for the Header component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.features.Header';

export default defineMessages({
  dashboardsLink: {
    id: `${scope}.dashboardsLink`,
    defaultMessage: 'Dashboards',
  },
  summaryLink: {
    id: `${scope}.summaryLink`,
    defaultMessage: 'Summary',
  },
  detailedLink: {
    id: `${scope}.detailedLink`,
    defaultMessage: 'Trade Details',
  },
  outliersLink: {
    id: `${scope}.outliersLink`,
    defaultMessage: 'Outliers',
  },
  pmOverviewLink: {
    id: `${scope}.pmOverviewLink`,
    defaultMessage: 'Portfolio Manager Overview',
  },
  traderOverviewLink: {
    id: `${scope}.traderOverviewLink`,
    defaultMessage: 'Trader Overview',
  },
  aboutLink: {
    id: `${scope}.aboutLink`,
    defaultMessage: 'About',
  },
  helpLink: {
    id: `${scope}.helpLink`,
    defaultMessage: 'Contact Us',
  },
  cartLink: {
    id: `${scope}.cartLink`,
    defaultMessage: 'Cart ({count})',
  },
  yourAccountLink: {
    id: `${scope}.yourAccountLink`,
    defaultMessage: 'Your Account',
  },
  settingsLink: {
    id: `${scope}.settingsLink`,
    defaultMessage: 'Settings',
  },
  yourUploadsLink: {
    id: `${scope}.yourUploadsLink`,
    defaultMessage: 'Your Uploads',
  },
  uploadTransactionFile: {
    id: `${scope}.uploadTransactionFile`,
    defaultMessage: 'Upload Transaction File',
  },
  adminPanelLink: {
    id: `${scope}.adminPanelLink`,
    defaultMessage: 'Admin Panel',
  },
  loginLink: {
    id: `${scope}.loginLink`,
    defaultMessage: 'Login',
  },
  logoutLink: {
    id: `${scope}.logoutLink`,
    defaultMessage: 'Logout',
  },
  contactEmail: {
    id: `${scope}.contactEmail`,
    defaultMessage:
      'ParametaSupport@tpicap.com?subject=Parameta Trading Analytics Inquiry',
  },
  requestAccountLink: {
    id: `${scope}.requestAccountLink`,
    defaultMessage: 'Request Account',
  },
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Filters',
  },
  pendingCheckbox: {
    id: `${scope}.pendingCheckbox`,
    defaultMessage: 'Pending',
  },
  subscriptionCheckbox: {
    id: `${scope}.subscriptionCheckbox`,
    defaultMessage: 'Subscription',
  },
  historicalCheckbox: {
    id: `${scope}.historicalCheckbox`,
    defaultMessage: 'Historical Data',
  },
  searchPlaceholder: {
    id: `${scope}.searchPlaceholder`,
    defaultMessage: 'Search for a filename',
  },
  dataMappingAdminLink: {
    id: `${scope}.dataMappingAdminLink`,
    defaultMessage: 'Data Mapping Admin',
  },
  dataMappingAuditLink: {
    id: `${scope}.dataMappingAuditLink`,
    defaultMessage: 'Data Mapping Audit',
  },
  ratesFieldMappingLink: {
    id: `${scope}.ratesFieldMappingLink`,
    defaultMessage: 'Rates Field Mapping',
  },
  ratesFixingProxyMappingLink: {
    id: `${scope}.ratesFixingProxyMappingLink`,
    defaultMessage: 'Rates Fixing Proxy Mapping',
  },
  LegalEntityMappingLink: {
    id: `${scope}.LegalEntityMappingLink`,
    defaultMessage: 'Legal Entity Mapping',
  },
  ratesFieldAuditLink: {
    id: `${scope}.ratesFieldAuditLink`,
    defaultMessage: 'Rates Field Mapping Audit',
  },
  ratesFixingProxyAuditLink: {
    id: `${scope}.ratesFixingProxyAuditLink`,
    defaultMessage: 'Rates Fixing Proxy Mapping Audit',
  },
  LegalEntityAuditLink: {
    id: `${scope}.LegalEntityAuditLink`,
    defaultMessage: 'Legal Entity Mapping Audit',
  },
});
